export default __webpack_public_path__ + "static/media/polygon-edit-active.d9e0ca94.svg";